import api from '../clients/api';
import { RelatedTopicsRequest, SearchRequest } from '@klab-berlin/api-sdk/lib/types/requests/Common';
import { handleUnauthorized } from '../utils/apiWrapper';
import { notifyBugsnagNetwork } from '../utils/bugsnagClient';

const search = {
  unifiedSearch,
  fetchRelatedTopics,
};

function unifiedSearch(searchParams: SearchRequest, abortSignal?: AbortSignal) {
  notifyBugsnagNetwork('search', 'unifiedSearch', { searchParams });
  return handleUnauthorized(() => api.search.unifiedSearch(searchParams, abortSignal));
}

function fetchRelatedTopics(params: RelatedTopicsRequest, abortSignal?: AbortSignal): Promise<string[]> {
  notifyBugsnagNetwork('search', 'fetchRelatedTopics', params);
  return handleUnauthorized(() => api.search.relatedTopics(params, abortSignal));
}

export default search;
